import ApiService from '../api.services';

const CollectedService = {
  add: async function (tag) {
    try {
      const response = await ApiService.post('/api/collecteds/list', {
        tag
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  get: async function (startedAt, finishedAt, userId, customerId) {
    try {
      const params = [
        `startedAt=${encodeURIComponent(startedAt)}`,
        `finishedAt=${encodeURIComponent(finishedAt)}`,
      ];
      if (userId) params.push(`userId=${encodeURIComponent(userId)}`);
      if (customerId) params.push(`customerId=${encodeURIComponent(customerId)}`);
      const response = await ApiService.get(`/api/collecteds/day/driver?${params.join("&")}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default CollectedService;

export { CollectedService };
